"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportType = void 0;
var ReportType;
(function (ReportType) {
    ReportType[ReportType["NON_SPECIFIC"] = 0] = "NON_SPECIFIC";
    ReportType[ReportType["AFBOUWKEUR"] = 1] = "AFBOUWKEUR";
    ReportType[ReportType["NOA"] = 2] = "NOA";
})(ReportType = exports.ReportType || (exports.ReportType = {}));
//# sourceMappingURL=reportType.enum.js.map